import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "235",
  "slug": "most-recognizable-places-satellite-view",
  "title": "The Most Recognizable Places on Earth From Satellite View",
  "excerpt": "Some places on Earth are so distinctive from above that even a glimpse of satellite imagery is enough to place them instantly. Here are the world's most recognizable landscapes as seen from space.",
  "date": "2026-03-19",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "There's a particular pleasure in the instant recognition — the moment when a satellite image resolves from abstraction into certainty. The shape of a coastline snapping into a known country. The geometry of a city revealing its identity. These are the landmarks of satellite geography."
    },
    {
      "type": "heading",
      "text": "The Grand Canyon: A Wound in the Earth"
    },
    {
      "type": "paragraph",
      "text": "From orbit, the Grand Canyon looks like a complex branching scar carved into the flat surface of the Colorado Plateau — a system of canyons so deep that their shadowed walls create dark features visible even in moderate-resolution imagery. Nothing else in the world produces quite the same visual signature."
    },
    {
      "type": "heading",
      "text": "The Nile Delta: Green Against Desert"
    },
    {
      "type": "paragraph",
      "text": "A vast triangle of deep green agriculture jutting into the beige-brown Sahara and then spreading into the blue of the Mediterranean. The hard geometric edge between irrigated farmland and desert is visible at virtually any scale — a landscape shaped by ten thousand years of civilization."
    },
    {
      "type": "heading",
      "text": "Manhattan: The Island That Built the Modern World"
    },
    {
      "type": "paragraph",
      "text": "A narrow, elongated island surrounded by rivers, connected by bridges, covered end-to-end with the highest building density in the Western hemisphere. Central Park — a precisely rectangular swath of green — is visible from orbit as a striking geometric negative space."
    },
    {
      "type": "heading",
      "text": "More Instantly Recognizable Places"
    },
    {
      "type": "list",
      "items": [
        "The Strait of Gibraltar — the narrow water gap between Europe and Africa",
        "The Korean Peninsula at night — the stark contrast between South Korean city lights and North Korean darkness",
        "Lake Baikal — the world's deepest lake, a 636 km straight line following an ancient rift valley",
        "The Maldives — thousands of coral atolls as rings of white sand and turquoise water",
        "The Great Barrier Reef — 2,300 kilometers of reef visible as turquoise and blue mosaic along the Queensland coast"
      ]
    },
    {
      "type": "heading",
      "text": "Why Instant Recognition Matters"
    },
    {
      "type": "paragraph",
      "text": "Instant recognition from satellite view reflects geographic fluency — an internalized library of place that allows you to orient quickly and think coherently about world geography. EarthGuessr is a machine for building this library. Every location you correctly identify adds to your visual vocabulary of place."
    }
  ]
};
